import * as Yup from "yup";

export const loginValidationSchema = Yup.object({
  identifier: Yup.string().required("Email or username is required"),
  password: Yup.string().required("Password is required"),
});
